import { render } from "./AgencyStatisticsView.vue?vue&type=template&id=2fafddc9&scoped=true"
import script from "./AgencyStatisticsView.vue?vue&type=script&lang=js"
export * from "./AgencyStatisticsView.vue?vue&type=script&lang=js"

import "./AgencyStatisticsView.vue?vue&type=style&index=0&id=2fafddc9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fafddc9"]])

export default __exports__